import { render, staticRenderFns } from "./c5.vue?vue&type=template&id=dcefd7ea&scoped=true"
import script from "./c5.vue?vue&type=script&lang=js"
export * from "./c5.vue?vue&type=script&lang=js"
import style0 from "./c5.vue?vue&type=style&index=0&id=dcefd7ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcefd7ea",
  null
  
)

export default component.exports